module.exports = __webpack_public_path__ + "img/20200713-6.ab177e56.png";